import { listClasses } from '@mui/material/List';
//
import { paper } from '../../css';

// ----------------------------------------------------------------------

export default function Popover(theme) {
  return {
    MuiPopover: {
      // TODO: Add a comment about the usage of the `disableScrollLock` prop
      defaultProps: {
        // disableScrollLock: true,
        // marginThreshold: null,
        // disableRestoreFocus: true,
      },
      styleOverrides: {
        paper: {
          ...paper({ theme, dropdown: true }),
          [`& .${listClasses.root}`]: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
  };
}
